import {
  VendorTaxonomyKey,
  SearchableVendorTaxonomyKey,
} from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';
import { getVendorTaxonomyId } from '@zola-helpers/client/dist/es/marketplace/vendorUtils';

import { TaxonomyNodeView } from '~/types/responseTypes';
import ApiService from '~/util/apiService';
import { StandardLogFn } from '~/util/logger';

export const getUnbookedVendorKeys = (
  excludedVendorTypes: (VendorTaxonomyKey | undefined)[]
): Promise<SearchableVendorTaxonomyKey[]> => {
  const excludedVendorTypeTaxonomyIds = excludedVendorTypes.map(getVendorTaxonomyId);
  return ApiService.get<TaxonomyNodeView[]>(
    `/web-marketplace-api/v1/account/unbooked-taxonomy-nodes`
  )
    .then((categories) => {
      return Promise.resolve(
        categories
          .filter((c) => !excludedVendorTypeTaxonomyIds.includes(c.id))
          .map((u) => u.key as SearchableVendorTaxonomyKey)
      );
    })
    .catch(() => Promise.resolve([]));
};

export const snoozeModal = () => {
  ApiService.put('/web-marketplace-api/v1/user-prompt/snooze?prompt_key=INQUIRY_MAINTENANCE').catch(
    StandardLogFn
  );
};
